import { render, staticRenderFns } from "./AccessTable.vue?vue&type=template&id=2005c9b5&scoped=true"
import script from "./AccessTable.vue?vue&type=script&lang=js"
export * from "./AccessTable.vue?vue&type=script&lang=js"
import style0 from "./AccessTable.vue?vue&type=style&index=0&id=2005c9b5&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2005c9b5",
  null
  
)

export default component.exports